import {FC, useEffect} from "react";

import './style.css';
import {Container, Form, Navbar, Row} from "react-bootstrap";
import LoginButton from "../../components/loginbutton/loginbutton";
import {useAuth0} from "@auth0/auth0-react";

interface WelcomeProps {}

const Welcome: FC<WelcomeProps> = ({ }) => {  {

    const { isAuthenticated, loginWithRedirect } = useAuth0();

    useEffect(() => {
        if (isAuthenticated) {
            window.location.href = "/portal";
        }
    }, [isAuthenticated])

  return (
      <Container fluid="md">
          <Navbar bg="light" expand="lg">
              <Container>
                  <LoginButton />
              </Container>
          </Navbar>
          <div className="welcomeForm">
            <img src="santa-claus.png" />
              <h1 className="welcomeSantaHeader">
                  <span>S</span>
                  <span>E</span>
                  <span>C</span>
                  <span>R</span>
                  <span>E</span>
                  <span>T</span>
                  <span> </span>
                  <span>S</span>
                  <span>A</span>
                  <span>N</span>
                  <span>T</span>
                  <span>A</span>
              </h1>
          </div>
      </Container>)
    }
}

export default Welcome;